import * as React from 'react';
export const IcCast = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 7a5 5 0 00-5 5 4.94 4.94 0 00.9 2.85 1 1 0 001.64-1.14 3 3 0 114.92 0 1 1 0 001.64 1.14c.587-.834.901-1.83.9-2.85a5 5 0 00-5-5zm.71 8.29a1.002 1.002 0 00-1.42 0l-4 4a1 1 0 00-.21 1.09A1 1 0 008 21h8a1 1 0 00.92-.62 1 1 0 00-.21-1.09l-4-4zM12 3a9 9 0 00-6.9 14.78 1 1 0 001.53-1.29 7 7 0 1110.74 0 .999.999 0 00.12 1.41 1 1 0 00.64.23.999.999 0 00.77-.35A9 9 0 0012 3z'
      fill='currentColor'
    />
  </svg>
);
